import React, { useContext, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import { setAccessories as setExploreDareAccessories } from '../features/explore/exploreDare/exploreDareSlice';
import { setAccessories as setComfortDareAccessories } from '../features/comfort/comfortDare/comfortDareSlice';
import { setAccessories as setDemoDareAccessories } from '../features/demo/demoDare/demoDareSlice';
import { setAccessories as setComfortLightDareAccessories } from '../features/comfort/comfortLightDare/comfortLightDareSlice';
import { setAccessories as setDemoLightDareAccessories } from '../features/demo/demoLightDare/demoLightDareSlice';
import { setAccessories as setOpenDareAccessories } from '../features/open/openDare/openDareSlice';
import { setAccessories as setOpenLightDareAccessories } from '../features/open/openLightDare/openLightDareSlice';
import { setAccessories as setOpenKinkyDareAccessories } from '../features/open/openKinkyDare/openKinkyDareSlice';
import AccessoryCardPopover from '../components/AccessoryCardPopover';
import StartNewGamePopover from '../components/StartNewGamePopover';
import { setGameStarted } from '../features/gamesStatus/gameStatusSlice';
import { resetGame } from '../features/contestants/contestantsSlice';
import { AuthContext } from '../auth/AuthContext';
import PopoverCard from '../components/PopoverCard';
import BackgroundContainer from '../components/BackgroundContainer';
import BaseButton from '../components/BaseButton';
import BaseHeader from '../components/BaseHeader';
import PremiumButton from '../components/PremiumButton';
import MenuButton from '../components/MenuButton';
import { useAuthStatus } from '../auth';
import { createGameSession } from '../features/gamesStatus/gameSessionApi';
import { v4 as uuidv4 } from 'uuid';



const ChooseLevel = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const {auth} = useContext(AuthContext)
  const [, status] = useAuthStatus();
  const isAuthenticated = status.isAuthenticated;
  const user = auth.data?.user
  const isPremium = user?.membership === 'Premium' || auth.data?.user?.membership === 'Supreme Premium';
  const gameStatus = useSelector((state) => state.gameStatus)
  const [anchorEl, setAnchorEl] = useState(null);
  const [accessoryPopoverOpen, setAccessoryPopoverOpen] = useState(false);
  const [newGamePopoverOpen, setNewGamePopoverOpen] = useState(false);
  const [premiumPopoverOpen, setPremiumPopoverOpen] = useState(false);
  const [authenticatedPopoverOpen, setAuthenticatedPopoverOpen] = useState(false);
  const [showUnleashedSoonPopover, setShowUnleashedSoonPopover] = useState(false);
  const [gameInfoPopoverOpen, setGameInfoPopoverOpen] = useState(false);
  const [gameInfoText, setGameInfoText] = useState('');
  const [navigateTo, setNavigateTo] = useState("/exploregame")
  const [gameType, setGameType] = useState("explore")
  const playerOne = useSelector((state) => state.contestants.playerOne);
  const playerTwo = useSelector((state) => state.contestants.playerTwo);
  const gameMode = useSelector((state) => state.contestants.gameMode);
  const relationshipType = useSelector((state) => state.contestants.relationshipType);
  const coupleType = useSelector((state) => state.contestants.coupleType);

  const handleButtonClick = (event, gameRoute) => {
    setAnchorEl(event.currentTarget);
    setGameType(gameRoute.replace(/\/|game/g, ''))
    setNavigateTo(gameRoute)
  };

  const handleGameClick = (game) => {
    if (isAuthenticated){
    setNavigateTo(game);
    setGameType(game.replace(/\/|game/g, ''))
    if (gameStatus.sessions[game.replace(/\/|game/g, '')].started === true) {
      setNewGamePopoverOpen(true)
    } else {
      setAccessoryPopoverOpen(true)
    }} else{
      setAuthenticatedPopoverOpen(true)
    }
  };
  const handlePremiumGameClick = (game) => {
    if(isPremium){
    setNavigateTo(game);
    setGameType(game.replace(/\/|game/g, ''))
    if (gameStatus.sessions[game.replace(/\/|game/g, '')].started === true) {
      setNewGamePopoverOpen(true)
    } else {
      setAccessoryPopoverOpen(true)
    }
    }else{
      setPremiumPopoverOpen(true)};
  };

  const handleStartGame = async (selectedAccessories) => {
    const sessionId = uuidv4();  // 🎯 generate UUID here
  
    try {
      await createGameSession({
        sessionId,
        typeOfGame: gameType,
        playerOneGender: playerOne.gender,
        playerTwoGender: playerTwo.gender,
        accessories: selectedAccessories,
        gameMode,
        relationshipType,
        coupleType,
      });
      
      dispatch(setGameStarted({ gameType, sessionId }));
  
      if (gameType === "explore") {
        dispatch(setExploreDareAccessories(selectedAccessories));
      } else if (gameType === "comfort") {
        dispatch(setComfortDareAccessories(selectedAccessories));
        dispatch(setComfortLightDareAccessories(selectedAccessories));
      } else if (gameType === "demo") {
        dispatch(setDemoDareAccessories(selectedAccessories));
        dispatch(setDemoLightDareAccessories(selectedAccessories));
      } else {
        dispatch(setOpenDareAccessories(selectedAccessories));
        dispatch(setOpenLightDareAccessories(selectedAccessories));
        dispatch(setOpenKinkyDareAccessories(selectedAccessories));
      }
  
      navigate(navigateTo);
    } catch (error) {
      console.error('Failed to create session:', error);
      // Optional: show error to user
    }
  };

  const handleCloseAccessoryPopover = () => {
    setAnchorEl(null);
  };

  const handleSubmitPopover = () => {
    setAnchorEl(null);
    navigate(navigateTo);
  }
  const handleStartNewGame = () => {
    dispatch(resetGame(gameType))
    setNewGamePopoverOpen(false);
    setAccessoryPopoverOpen(true);

  }
  const handleContinue = () => {
    setNewGamePopoverOpen(false)
    navigate(navigateTo)
  }

  return (
    <div>
      <BackgroundContainer>
        <MenuButton
          showLogin={true}
          showAccount={true}
          faq={true}
          showDownload={true}
        />
        <Box sx={{ flexGrow: 1, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <BaseHeader
            sx={{
              textAlign: 'center',
              fontSize: '3.8rem',
              '@media (max-width: 450px)': { fontSize: '3.6rem' },
              '@media (max-width: 410px)': { fontSize: '3.3rem' },
              '@media (max-width: 376px)': { fontSize: '2.9rem' },
              '@media (max-width: 320px)': { fontSize: '2.9rem' },
            }}
          >
            What Calls You?
          </BaseHeader>
          <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', paddingBottom: '25vh' }}>
        {!isPremium && <BaseButton onClick={() => handleGameClick('/demogame')}
        showQuestionMark={true}
        onQuestionClick={() => {
          setGameInfoText("A very basic game mode to give you a taste of what the game is like.");
          setGameInfoPopoverOpen(true);
        }}
        >Demo Version</BaseButton>}
        <PremiumButton onClick={() => handlePremiumGameClick('/exploregame')}
        isPremium= {isPremium}
        showQuestionMark={true}
        onQuestionClick={() => {
          setGameInfoText("A Mindful and Connecting game, to strengthen the bond and trust between you.");
          setGameInfoPopoverOpen(true);
        }}
        >Intimacy</PremiumButton>
        <PremiumButton onClick={() => handlePremiumGameClick('/comfortgame')}
        isPremium= {isPremium}
        showQuestionMark={true}
        onQuestionClick={() => {
          setGameInfoText("Explore your sexuality. Get to know yourself and your partner, with a playful game full of pleasure.");
          setGameInfoPopoverOpen(true);
        }}
        >Desire</PremiumButton>
        <PremiumButton onClick={() => setShowUnleashedSoonPopover(true)}
        disabled={true}
        isPremium= {isPremium}
        showQuestionMark={true}
        onQuestionClick={() => {
          setGameInfoText("For open minded - curious people who enjoy to play and discover how things are beyond their comfort zone.");
          setGameInfoPopoverOpen(true);
        }}
        >Unleashed</PremiumButton>
        <BaseButton onClick={() => navigate('/choosegamemode')}>Back</BaseButton>
        <StartNewGamePopover
          open={newGamePopoverOpen}
          onClose={() => setNewGamePopoverOpen(false)}
          onStartNewGame={handleStartNewGame}
          onContinue={handleContinue}
          gameType={gameType}
        />
        <AccessoryCardPopover
          open={accessoryPopoverOpen}
          onClose={() => setAccessoryPopoverOpen(false)}
          onStartGame={handleStartGame}
          gameType={gameType}
        />
        <PopoverCard
        mainText="This game mode requires a premium subscription." 
        open={premiumPopoverOpen} 
        onClose={() => setPremiumPopoverOpen(false)}
        showButtonOne={true}
        textButtonOne="CLICK HERE TO PURCHASE"
        onButtonOne={()=> navigate("/account/paymentpage")} />
        <PopoverCard
        open={showUnleashedSoonPopover}
        onClose={() => setShowUnleashedSoonPopover(false)}
        mainText={
          <>
            <span>This game hasn't launched yet.</span>
            <br />
            <br />
            <span>It’s a <b>bold and kinky experience</b>, crafted for those ready to explore desire, stretch boundaries, and unlock deeper connection.</span>
          </>
        }
        showButtonOne={false}
        showButtonTwo={false}
      />
        <PopoverCard
        mainText="To play you need to have a free account." 
        open={authenticatedPopoverOpen} 
        onClose={() => setAuthenticatedPopoverOpen(false)}
        showButtonOne={true}
        textButtonOne="Login or Sign Up For FREE"
        onButtonOne={()=> navigate("/account/login")} />

        <PopoverCard
          open={gameInfoPopoverOpen}
          onClose={() => setGameInfoPopoverOpen(false)}
          mainText={gameInfoText}
          showButtonOne={false}
          showButtonTwo={false}
        />
        {/* <CustomButton id = "explore" onClick={(e) => handleButtonClick(e, "/exploregame")} >Explore Each Other</CustomButton>
            <CustomButton id = "comfort" onClick={(e) => handleButtonClick(e, "/comfortgame")}>Enjoy Each Other</CustomButton>
            <CustomButton id = "open" onClick={(e) => handleButtonClick(e, "/opengame")}>Open Minded</CustomButton>
            <CustomButton onClick={() => navigate(-1)}>Back</CustomButton>
            <AccessoryPopover anchorEl={anchorEl} handleClose={handleCloseAccessoryPopover} handleSubmit = {handleSubmitPopover} /> */}

        
            </Box>
          </Box>
      </BackgroundContainer>
    </div>
  )
}

export default ChooseLevel